var set = require('regenerate')();

set.addRange(0x1E290, 0x1E2AE);
module.exports = set;